import { render, staticRenderFns } from "./NewAppeals.vue?vue&type=template&id=7e9d27b3&scoped=true&"
import script from "./NewAppeals.vue?vue&type=script&lang=js&"
export * from "./NewAppeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9d27b3",
  null
  
)

export default component.exports